import { render } from "./MTableCell.vue?vue&type=template&id=a528b342&scoped=true&ts=true"
import script from "./MTableCell.vue?vue&type=script&lang=ts"
export * from "./MTableCell.vue?vue&type=script&lang=ts"

import "./MTableCell.vue?vue&type=style&index=0&id=a528b342&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a528b342"]])

export default __exports__